import { useState, useEffect, useRef } from "react"
import WebViewer from "@pdftron/webviewer"
import Loading from "components/Loading/Loading"
import { useGetEnvVars } from "api/hooks/enum"

// styles
import "./PDFTronPreview.scss"

const PDFTronPreview = ({ id = null, metadata, file, json = null, height = 300, width = 200 }) => {
  const { data: envVars } = useGetEnvVars()
  const instanceRef = useRef(null)
  const viewerRef = useRef(null)
  const [isLoading, setIsLoading] = useState(true)
  const [thumbnail, setThumbnail] = useState(null)

  const getExtensions = (file) => {
    if (typeof file === "string") {
      let segments = file.split("?AWSAccessKeyId=")
      let originalUrl = segments[0]
      let urlSeg = originalUrl.split(".")
      let extension = urlSeg[urlSeg.length - 1]
      return extension
    }

    return
  }

  useEffect(() => {
    let configs = {
      path: "/lib",
      licenseKey: envVars?.PDFTRON_LICENSE_KEY,
    }
    if (typeof file === "string") {
      configs.initialDoc = file
      configs.extension = getExtensions(file)
    }

    import("@pdftron/webviewer")
      .then(() => {
        WebViewer(configs, viewerRef.current).then(async (instance) => {
          const { documentViewer } = instance.Core
          instanceRef.current = instance

          if (file && file instanceof File) {
            instance?.UI?.loadDocument(file, {
              filename: file.name,
            })
          }
          documentViewer.addEventListener("documentLoaded", () => {
            const doc = documentViewer.getDocument()
            const pageNumber = 1
            const zoom = 1

            doc.loadCanvas({
              pageNumber,
              zoom,
              drawComplete: async (thumbnail) => {
                setThumbnail(thumbnail)
                setIsLoading(false)
              },
            })
          })
        })
      })
      .catch((e) => setIsLoading(false))
  }, [])

  useEffect(() => {
    try {
      if (instanceRef.current && file) {
        let instance = instanceRef.current
        const { documentViewer } = instance.Core

        instance?.UI?.loadDocument(file, {
          filename: file.name,
        })

        setTimeout(() => {
          const doc = documentViewer.getDocument()
          const pageNumber = 1
          const zoom = 1

          doc.loadCanvas({
            pageNumber,
            zoom,
            drawComplete: async (thumbnail) => {
              setThumbnail(thumbnail)
              setIsLoading(false)
            },
          })
        }, [1000])
      }
    } catch (e) {
      setIsLoading(false)
    }
  }, [file, instanceRef])

  return (
    <div
      id={id}
      className="pdftron-preview-container"
    >
      <div
        className="hidden"
        ref={viewerRef}
      ></div>
      {thumbnail && isLoading === false ? (
        <img
          src={thumbnail.toDataURL()}
          alt="doc-thumbnail"
          height={height}
          width={width}
        />
      ) : (
        <Loading className="loading-styles" />
      )}
    </div>
  )
}

export default PDFTronPreview
